import React from "react";
import { motion } from "framer-motion";

/**
 * Animated aurora mesh — multiple blurred orbs drifting & morphing.
 * Use as absolute layer inside a relative parent (overflow-hidden).
 */
const Aurora = ({ variant = "cyan" }) => {
    const palettes = {
        cyan: [
            "radial-gradient(circle, rgba(0,229,255,0.55), transparent 60%)",
            "radial-gradient(circle, rgba(124,92,255,0.45), transparent 60%)",
            "radial-gradient(circle, rgba(0,85,255,0.35), transparent 60%)",
        ],
        violet: [
            "radial-gradient(circle, rgba(124,92,255,0.55), transparent 60%)",
            "radial-gradient(circle, rgba(0,229,255,0.35), transparent 60%)",
            "radial-gradient(circle, rgba(255,44,212,0.30), transparent 60%)",
        ],
        soft: [
            "radial-gradient(circle, rgba(0,229,255,0.25), transparent 60%)",
            "radial-gradient(circle, rgba(124,92,255,0.22), transparent 60%)",
        ],
    };
    const colors = palettes[variant] || palettes.cyan;
    return (
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
            {colors.map((c, i) => (
                <motion.div
                    key={i}
                    className="absolute rounded-full"
                    style={{
                        width: 520 + i * 80,
                        height: 520 + i * 80,
                        background: c,
                        filter: "blur(80px)",
                        top: `${[-10, 40, 60][i % 3]}%`,
                        left: `${[10, 60, 25][i % 3]}%`,
                    }}
                    animate={{
                        x: [0, 80, -60, 0],
                        y: [0, -60, 40, 0],
                        scale: [1, 1.15, 0.95, 1],
                    }}
                    transition={{
                        duration: 18 + i * 4,
                        repeat: Infinity,
                        ease: "easeInOut",
                    }}
                />
            ))}
        </div>
    );
};

export default Aurora;
